/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Facts_FoundedInputs */

const en_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Founded 2026`)
};

const de_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegruendet 2026`)
};

const fr_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondée en 2026`)
};

const es_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundada en 2026`)
};

const it_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondata nel 2026`)
};

const nl_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgericht in 2026`)
};

const pl_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalozona w 2026`)
};

const fi_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perustettu 2026`)
};

const da_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlagt 2026`)
};

const sv_about_facts_founded = /** @type {(inputs: About_Facts_FoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundat 2026`)
};

/**
* | output |
* | --- |
* | "Founded 2026" |
*
* @param {About_Facts_FoundedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_facts_founded = /** @type {((inputs?: About_Facts_FoundedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Facts_FoundedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_facts_founded(inputs)
	if (locale === "fr") return fr_about_facts_founded(inputs)
	if (locale === "es") return es_about_facts_founded(inputs)
	if (locale === "it") return it_about_facts_founded(inputs)
	if (locale === "nl") return nl_about_facts_founded(inputs)
	if (locale === "pl") return pl_about_facts_founded(inputs)
	if (locale === "fi") return fi_about_facts_founded(inputs)
	if (locale === "da") return da_about_facts_founded(inputs)
	if (locale === "sv") return sv_about_facts_founded(inputs)
	return en_about_facts_founded(inputs)
});